import {createStore, compose, applyMiddleware} from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from '../reducers';
import { watchGas } from '../sagas/gasSaga';

export default function configureStore(initialState) {
  const sagaMiddleware = createSagaMiddleware();

  const middlewares = [
    sagaMiddleware,
  ];

  const store = createStore(rootReducer, initialState, compose(
    applyMiddleware(...middlewares),
   // window.devToolsExtension ? window.devToolsExtension() : f => f  // remove for the final build
    )
  );

  sagaMiddleware.run(watchGas);

  return store;
}
